export function setProfessionId(id: number) {
  return {
    type: 'SET_PROFESSION',
    data: id
  }
}
